import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import SpareParameterForm from "components/spares/parameters/SpareParameterForm";
import { updateSpareParameter } from "graphql/mutations";
import {
  getSpare,
  getSpareParameter,
  spareParametersBySpareID,
} from "graphql/queries";

const SpareParameterUpdateForm = ({ spareID, spareParameterId, onSuccess }) => {
  const navigate = useNavigate();
  const [spareParameter, setSpareParameter] = useState();
  const [companyID, setCompanyID] = useState("");

  async function onSubmit(valuesParam) {
    try {
      const { parameterID, parameterValue } = valuesParam;

      if (spareParameter.parameterID !== parameterID) {
        const oldSpareParameterData = await API.graphql(
          graphqlOperation(spareParametersBySpareID, {
            spareID: spareParameter.spareID,
            filter: {
              and: [
                {
                  parameterID: { eq: parameterID },
                },
              ],
              deletedAt: { attributeExists: false },
            },
          })
        );
        const oldSpareParameterItems =
          oldSpareParameterData.data.spareParametersBySpareID.items;

        if (oldSpareParameterItems.length > 0) {
          toast.error(strings.parameterExists);
          return;
        }
      }

      await API.graphql({
        query: updateSpareParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            id: spareParameterId,
            parameterID,
            parameterValue,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/spares");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchSpareParameter(id) {
    try {
      const spareParameterData = await API.graphql(
        graphqlOperation(getSpareParameter, { id })
      );
      const spareParameterItem = spareParameterData.data.getSpareParameter;
      if (!spareParameterItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/spares");
        return;
      }
      setSpareParameter({
        ...spareParameterItem,
      });
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  async function getCompanyFromSpare(id) {
    try {
      const spareData = await API.graphql(graphqlOperation(getSpare, { id }));
      const spareItem = spareData.data.getSpare;
      if (!spareItem) {
        toast.error(strings.responses.errorFetchSpare);
        return;
      }
      setCompanyID(spareItem.companyID);
    } catch (err) {
      toast.error(strings.responses.errorFetchSpare);
    }
  }

  useEffect(() => {
    fetchSpareParameter(spareParameterId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spareParameterId]);

  useEffect(() => {
    getCompanyFromSpare(spareID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spareID]);

  if (!spareParameter || !companyID) return <Loader />;

  return (
    <div>
      <SpareParameterForm
        onSubmit={onSubmit}
        type="update"
        initialValues={spareParameter}
        companyID={companyID}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Parámetro de Repuesto",
    successUpdated: "Parámetro de Repuesto actualizado con éxito",
    parameterExists: "El parámetro ya existe en el repuesto",
    responses: {
      errorFetch: "Error al consultar el parámetro de repuesto",
      errorFetchSpare: "Error al consultar repuesto",
    },
  },
});

export default SpareParameterUpdateForm;
